<template>
  <div>
    <div class="input-group">
      <div class="input-group-prepend"><span class="input-group-addon"><i class="far fa-search"></i></span></div>
      <input type="text" placeholder="Search" class="form-control" v-model="searchText">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportFilterSearchBar',
  model: {
    event: 'update'
  },
  props: {
    value: String
  },
  data() {
    return {
      searchText: this.value || ''
    }
  },
  watch: {
    searchText: function() {
      this.$emit('update', this.searchText)
    }
  }
}
</script>